import { z } from "zod";
import {
  createTimelineDraft,
  type TimelineEventDraft,
} from "@/features/timeline/timeline.types";

export const timelineEventDraftSchema = z.object({
  description: z.string().trim().min(1, "Description is required."),
  eraLabel: z.string().trim().min(1, "Era label is required."),
  title: z.string().trim().min(1, "Title is required."),
});

export function parseTimelineEventDraft(input: TimelineEventDraft) {
  return timelineEventDraftSchema.parse(input);
}

export function createTimelineEventDraft(
  overrides: Partial<TimelineEventDraft> = {},
) {
  return createTimelineDraft(overrides);
}
